import React from 'react';
import { IonButton, IonCol, IonGrid, IonInput, IonRow } from '@ionic/react';
import { DisponibilidadeDia } from './disponibilidadeCatalogo';

const dias = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];

export default function DisponibilidadePorDiaEditor({ value, onChange }: {
  value: DisponibilidadeDia[]; onChange: (value: DisponibilidadeDia[]) => void;
}) {
  const update = (dia: number, horarios: DisponibilidadeDia['horarios']) => {
    onChange(Array.from({ length: 7 }, (_, index) => ({ dia: index,
      horarios: index === dia ? horarios : (value.find(day => day.dia === index)?.horarios || []) })));
  };
  return <div className="catalogo-dias-card" aria-label="Horários por dia da semana">
    <p className="catalogo-dias-card-desc">Cada dia tem seus próprios horários. Dias sem faixas ficam indisponíveis.</p>
    {dias.map((label, dia) => {
      const horarios = value.find(day => day.dia === dia)?.horarios || [];
      return <div key={dia} style={{ marginBottom: 16 }}>
        <strong>{label}</strong>
        {!horarios.length && <p>Indisponível neste dia</p>}
        {horarios.map((range, index) => <IonGrid key={index} style={{ padding: 0 }}><IonRow>
          <IonCol size="5"><IonInput type="time" aria-label={`Início ${label} ${index + 1}`} value={range.inicio}
            onIonChange={(event: any) => update(dia, horarios.map((item, position) => position === index ? { ...item, inicio: event.detail.value || '' } : item))} /></IonCol>
          <IonCol size="5"><IonInput type="time" aria-label={`Fim ${label} ${index + 1}`} value={range.fim}
            onIonChange={(event: any) => update(dia, horarios.map((item, position) => position === index ? { ...item, fim: event.detail.value || '' } : item))} /></IonCol>
          <IonCol size="2"><IonButton fill="clear" aria-label={`Remover faixa ${label} ${index + 1}`}
            onClick={() => update(dia, horarios.filter((_, position) => position !== index))}>Remover</IonButton></IonCol>
        </IonRow></IonGrid>)}
        <IonButton fill="outline" size="small" aria-label={`Adicionar faixa ${label}`}
          onClick={() => update(dia, [...horarios, { inicio: '', fim: '' }])}>Adicionar faixa</IonButton>
      </div>;
    })}
  </div>;
}
